import { createSelector } from 'reselect'
import SummaryFiltering from '../../../utils/SummaryFiltering'
import { getScrollableFromDate, getScrollableToDate } from './dates'
import { getFilteredRoomsWithEvents } from './rooms'

export const calculateSummary = (from: Date, to: Date) => {
  return createSelector(
    [getFilteredRoomsWithEvents],
    rooms => SummaryFiltering(rooms, from, to),
  )
}

export const getCalculatedSummary = createSelector(
  [getFilteredRoomsWithEvents, getScrollableFromDate, getScrollableToDate],
  (rooms, from, to) => SummaryFiltering(rooms, from, to),
)
